import { useState, useEffect } from 'react'
import { DeliveryTimes } from '../types'
import { getHash } from '../utils/Crypto'
import { fetchDeliveryTimes } from './deliverytimes_api'

export interface DeliveryTimeOptions {
  cartItems: any
  deliveryCountry: string
  mode?: string
}

export const useDeliveryTimes = (options: DeliveryTimeOptions) => {
  const [deliveryTimes, setDeliveryTimes] = useState<DeliveryTimes | undefined>(
    undefined,
  )

  const signature = getHash(options)

  useEffect(() => {
    fetchDeliveryTimes(options).then(response => {
      if (response.error == 0) {
        setDeliveryTimes(response.data)
      }
    })
  }, [signature])

  return deliveryTimes
}
